import type { MenuPrincipal } from '@malgoos/shared';

/**
 * Fase 2 (W31, itens 5.1 a 5.5 e decisão 6 de 05/10): menus cuja navegação não segue "um módulo por aba".
 *  - `grupos`: abas de primeiro nível na ordem dada, cada uma com as sub-abas que declaram `grupo` (de qualquer módulo),
 *    na `posicao` delas. Rótulo do grupo em `navegacao.<menu>.<grupo>` (i18n do núcleo).
 *  - `linha`: uma só linha de abas, com as abas de todos os módulos do menu na `posicao` delas.
 * Os caminhos não mudam (`/<menu>/<slug>/<aba>`): só a composição da navegação. Menu ausente aqui segue por módulos.
 */
export type DeclaracaoNavegacao = { tipo: 'grupos'; grupos: readonly string[] } | { tipo: 'linha' };

export const NAVEGACAO_MENUS: Partial<Record<MenuPrincipal, DeclaracaoNavegacao>> = {
  cadastros: { tipo: 'grupos', grupos: ['cadastros', 'servicos', 'financeiro', 'agenda', 'estoque'] },
  financeiro: { tipo: 'linha' },
  // Lote de 21/10 (item 4): o grupo Pessoas recebe "Usuários e acessos" do Admin; os outros grupos são os módulos de sempre.
  pessoas: { tipo: 'grupos', grupos: ['pessoas'] },
};
